var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoogle2(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 25,
    viewBox: "0 0 23 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.44135 14.7991L4.66583 17.8705L1.83132 17.9341C0.984214 16.2673 0.503723 14.3601 0.503723 12.3335C0.503723 10.3738 0.95297 8.5257 1.74929 6.89844H1.7499L4.27341 7.38926L5.37886 10.0504C5.1475 10.766 5.02139 11.5342 5.02139 12.3335C5.02148 13.201 5.1696 14.0322 5.44135 14.7991Z",
    fill: "#FBBB00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5887 10.1257C22.7166 10.8406 22.7833 11.5789 22.7833 12.3335C22.7833 13.1796 22.6995 14.0049 22.5397 14.801C21.9974 17.5101 20.5805 19.8757 18.6176 21.5497L18.617 21.5491L15.4385 21.377L14.9886 18.3978C16.2911 17.5874 17.309 16.3192 17.8452 14.801H11.8884V10.1257H17.9321H22.5887Z",
    fill: "#518EF8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6169 21.5491L18.6176 21.5498C16.7085 23.1777 14.2834 24.1517 11.6436 24.1517C7.40126 24.1517 3.7129 21.6361 1.83136 17.9342L5.44139 14.7991C6.38214 17.4627 8.80413 19.3589 11.6436 19.3589C12.864 19.3589 14.0074 19.0089 14.9885 18.3978L18.6169 21.5491Z",
    fill: "#28B446"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7541 3.23609L15.1452 6.37049C14.1298 5.69713 12.9295 5.30815 11.6436 5.30815C8.73986 5.30815 6.27257 7.29125 5.37894 10.0504L1.74994 6.89843H1.74933C3.60332 3.10623 7.3382 0.51532 11.6436 0.51532C14.3465 0.51532 16.8248 1.53676 18.7541 3.23609Z",
    fill: "#F14336"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle2);
export default __webpack_public_path__ + "static/media/google2.cc1afd82be6dc85492513dadbc356f98.svg";
export { ForwardRef as ReactComponent };